import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import UIkit from 'uikit'

//  components
import Icon from 'app/views/components/Icon'

import { addUrlActivity } from 'app/state/modules/hacker'

// Utils
import analytics from 'app/views/utils/analytics'


const propTypes = {
  url: PropTypes.string,
  path: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
}

const defaultProps = {
  url: '',
}

class BrowserTab extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      url: '',
      urlField: '',
      source: '',
      show_source: false,
      historyCounter: 0,
      historyTop: 0,
    }
    this.handleViewSourceClick = this.handleViewSourceClick.bind(this)
    this.handleViewBrowserClick = this.handleViewBrowserClick.bind(this)
    this.handleBackClick = this.handleBackClick.bind(this)
    this.handleForwardClick = this.handleForwardClick.bind(this)
    this.handleOnURLChange = this.handleOnURLChange.bind(this)
    this.handleOnURLKeyPress = this.handleOnURLKeyPress.bind(this)
    this.handleGoClick = this.handleGoClick.bind(this)
  }

  componentDidMount() {
    if (this.props.url !== '') {
      this.setState({ url: this.props.url })
    }

    // this.receiveMessage = (evt) => {
    //   if (evt.data === 'MM:3PCunsupported') {
    //     this.thirdPartyModal.modal.show()
    //   }
    // }
    // window.addEventListener('message', this.receiveMessage, false)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.requestCount > this.props.requestCount) {
      this.setState({
        historyCounter: this.state.historyCounter + 1,
        historyTop: this.state.historyCounter + 1,
      })
    }

    // Only set the url state if this is an initial load, or a reset
    // otherwise, the page will reload (because the iframe is getting a new src
    // when links are clicked
    if (this.state.url === '' || nextProps.url === '') {
      this.setState({
        url: nextProps.url,
      })
    }

    if (nextProps.proxy && nextProps.active) {
      const path = 'path' in nextProps ? nextProps.path : ''
      const search = 'search' in nextProps ? nextProps.search : ''

      this.setState({
        show_source: false,
        urlField: `${nextProps.cleanUrl}${path}${search}`,
      })
    } else {
      this.setState({
        show_source: false,
        urlField: `${nextProps.cleanUrl}`,
      })
    }
  }

  handleViewSourceClick() {
    analytics.track('click-view-source', {
      lessonId: this.props.match.params.id,
    })

    window.addEventListener('message', (event) => {
      if (event.data.action === 'source') {
        const source = event.data.data.replace(`
<script>
window.onload = function() {
    window.addEventListener('message', function(event) {
        if (event.data.action == "source") {
            window.parent.postMessage({"action": "source", "data": document.documentElement.innerHTML}, "*");
        }
    });
    window.parent.postMessage({
        "action": "location",
        "pathname": document.location.pathname,
        "search": document.location.search
    }, "*");
}
</script>
`, '')
        this.setState({
          source,
          show_source: true,
        })
      }
    }, false)

    const iframe = document.getElementById('iframe')
    iframe.contentWindow.postMessage({ action: 'source' }, '*')
  }

  handleViewBrowserClick() {
    analytics.track('click-view-browser', {
      lessonId: this.props.match.params.id,
    })

    this.setState({ show_source: false })
  }

  handleBackClick() {
    analytics.track('click-browser-back', {
      lessonId: this.props.match.params.id,
    })
    if (this.state.historyCounter > 1) {
      window.history.back()
      this.setState({ historyCounter: this.state.historyCounter - 1 }, () => {
      })
    }
  }

  handleForwardClick() {
    analytics.track('click-browser-forward', {
      lessonId: this.props.match.params.id,
    })

    if (this.state.historyCounter < this.state.historyTop) {
      window.history.forward()
      this.setState({ historyCounter: this.state.historyCounter + 1 }, () => {

      })
    }
  }

  handleOnURLChange(e) {
    this.setState({
      urlField: e.target.value,
    })
  }

  handleOnURLKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleGoClick()
    }
  }

  handleGoClick() {
    const { xAppData } = this.props
    let url = ''
    if (this.props.realUrlTabsGenerated) {
      const indexHttp = this.state.urlField.indexOf('http://')
      const indexHttps = this.state.urlField.indexOf('https://')
      const indexFile = this.state.urlField.indexOf('file://')
      const indexOfEnd = this.state.urlField.indexOf('/', 8) === -1 ? this.state.urlField.length : this.state.urlField.indexOf('/', 8)
      let baseUrl = ''
      if (indexHttp > -1) {
        baseUrl = this.state.urlField.slice(7, indexOfEnd)
      } else if (indexHttps > -1) {
        baseUrl = this.state.urlField.slice(8, indexOfEnd)
      } else if (indexFile > -1) {
        baseUrl = ''
        UIkit.modal.alert(`
          <h2>Invalid Protocol</h2>
          <p>This URL is invalid. We only support the <code>https://</code> and <code>http://</code> protocols in our Sandbox Browser.</p>
          <p>Our lessons will not instruct you to use <code>file://</code> in the Browser URL, so please take a closer look at the instructions to see where things may have gone wrong.</p>
        `)
      } else {
        baseUrl = ''
        UIkit.modal.alert(`
          <h2>Invalid Protocol</h2>
          <p>This URL is invalid. We only support the <code>https://</code> and <code>http://</code> protocols in our Sandbox Browser.</p>
          <p>Our lessons will not instruct you to use other protocols in the Browser URL, so please take a closer look at the instructions to see where things may have gone wrong.</p>
        `)
      }
      if (baseUrl && baseUrl !== '') {
        const firstMatch = baseUrl
        if (this.props.proxyTabsData && this.props.proxyTabsData[firstMatch] && this.props.proxyTabsData[firstMatch].realUrl) {
          url = this.state.urlField.replace('http://', 'https://').replace(firstMatch, this.props.proxyTabsData[firstMatch].realUrl)
        } else {
          return
        }
      } else {
        return
      }
    } else {
      url = this.state.urlField.replace('http://', 'https://').replace(this.props.cleanUrl, xAppData && xAppData['xAppHost'] ? `https://${xAppData['xAppHost']}` : this.props.url)
    }
    analytics.track('click-browser-go', {
      lessonId: this.props.match.params.id,
      url,
    })
    if (this.props.match.params.id) {
      this.props.addUrlActivity(this.props.match.params.id, url)
    }
    if (this.state.url === url) {
      // This means the URL hasn't changed, but the user still clicked the Go
      // button. We need to refresh the iFrame's contents, so I'm just resetting
      // the URL in the state.
      this.setState({
        url: '',
      }, () => {
        this.setState({
          url,
        })
      })
    } else {
      this.setState({
        url,
      })
    }
  }

  renderLoader() {
    if (this.props.compiling) {
      return (
        <>
          <div data-uk-spinner="" />
          <p data-test-id="compiling-code-msg">Compiling Code...</p>

        </>
      )
    }
    if (this.props.proxyStatus === 'error') {
      return (
        <>
          <div className="uk-flex uk-flex-middle uk-flex-center uk-flex-column uk-margin-top">
            <p data-test-id="compiling-code-msg" className="uk-width-large">
              Oops! It seems there was an error while loading your sandbox.
              Click in the "Reset Sandbox" button to request another one.
            </p>
            <button
              onClick={() => {
                document.getElementById('proxy-reset').click()
              }}
              className="uk-button  uk-button-primary uk-button-small uk-margin-small-top uk-flex"
              type="button"

            >
              <Icon className="uk-margin-small-right" name="restart" ratio={0.8} />
              <span>Reset Sandbox</span>
            </button>
          </div>
        </>
      )
    }
    return (
      <>
        <div data-uk-spinner="" />
        <p data-test-id="loading-sandbox-msg"> Loading Sandbox...</p>
      </>
    )
  }

  render() {
    const display = (this.props.active) ? ('inline') : ('none')
    const style = {
      display,
      height: '100%',
    }
    let urlBarWidth = 'calc(100% - 250px)'
    if (this.props.proxy === false) {
      urlBarWidth = 'calc(100% - 130px)'
    }
    const { showUrlBar } = this.props
    const showUrlBarTab = (this.props.contentType !== 'native') && showUrlBar
    return (
      <>
        <div style={style} data-test-id="browser-tab">
          {showUrlBarTab ? (
            <div style={{
              width: '100%',
              height: 40,
              background: '#EEEEEE',
              paddingTop: 10,
              zIndex: 1,
              borderTop: '1px solid #AAA',
            }}
            >
              {(this.state.historyCounter > 1) ? (
                <Icon
                  className="uk-text-primary"
                  name="arrow-left-s"
                  onClick={this.handleBackClick}
                />
              )
                : (
                  <Icon className="uk-text-muted" name="arrow-left-s" style={{ width: 20, padding: 5 }} />
                )}

              {(this.state.historyCounter < this.state.historyTop) ? (
                <Icon
                  onClick={this.handleForwardClick}
                  className="uk-text-primary"
                  name="arrow-right-s"
                />
              )
                : (
                  <Icon className="uk-text-muted" name="arrow-right-s" style={{ width: 20, padding: 5 }} />
                )}

              <input
                className="uk-input uk-form-width-large"
                type="text"
                placeholder="http://"
                style={{ height: 28, width: urlBarWidth }}
                spellCheck={false}
                onChange={this.handleOnURLChange}
                value={this.state.urlField}
                onKeyPress={this.handleOnURLKeyPress}
              />
              <button
                className="uk-button uk-button-default uk-button-small"
                style={{
                  textTransform: 'none',
                  fontSize: 12,
                  height: 28,
                  width: 50,
                }}
                type="button"
                onClick={this.handleGoClick}
              >
                Go
              </button>

              {this.props.proxy && this.state.show_source && (
                <button
                  className="uk-button uk-button-secondary uk-button-small"
                  style={{
                    textTransform: 'none',
                    marginLeft: 7,
                    fontSize: 12,
                    height: 28,
                    width: 120,
                  }}
                  type="button"
                  onClick={this.handleViewBrowserClick}
                  data-test-id="view-browser-btn"
                >
                  View Browser
                </button>
              )}
              {this.props.proxy && this.state.show_source === false && (
                <button
                  data-test-id="view-source-btn"
                  className="uk-button uk-button-primary uk-button-small"
                  style={{
                    textTransform: 'none',
                    marginLeft: 7,
                    fontSize: 12,
                    height: 28,
                    width: 120,
                  }}
                  type="button"
                  onClick={this.handleViewSourceClick}
                >
                  View Source
                </button>
              )}
            </div>
          )
            : (
              <div
                style={{
                  width: '100%',
                  height: 0,
                  background: '#EEEEEE',
                  paddingTop: 10,
                  zIndex: 1,
                  borderTop: '1px solid #AAA',
                  borderBottom: '1px solid #AAA',
                }}
              />
            )}
          <div style={{ height: showUrlBarTab ? ('calc(100% - 100px)') : ('calc(100% - 60px)') }}>
            <div
              style={{
                height: '100%',
                width: '100%',
              }}
            >
              {(
                this.props.compiling === true
                || this.state.url === ''
                || (
                  this.props.state.proxy.requests.length === 0
                  && this.props.contentType !== 'no-proxy'
                )
                || (
                  this.props.state.proxy.requests.length > 0
                  && this.props.state.proxy.requests[0].response === null
                )
              )
                && (
                  <div className="uk-section uk-text-center">
                    <div className="uk-container">
                      {this.renderLoader()}
                    </div>
                  </div>
                )}
              <textarea
                data-test-id="source-code-textarea"
                value={this.state.source}
                style={{
                  height: 'calc(100% - 30px)',
                  width: 'calc(100% - 30px)',
                  border: 'none',
                  padding: 15,
                  lineHeight: 1,
                  fontFamily: "Menlo, Monaco, Consolas, 'Courier New', monospace",
                  fontSize: 12,
                  display: (this.state.show_source || this.props.compiling) ? 'block' : 'none',
                  backgroundColor: '#FFFFFF',
                  color: '#000000',
                  resize: 'none',
                  overflowY: 'scroll',
                }}
                onChange={() => { }}
              />
              <iframe
                title="Browser"
                width="100%"
                height="100%"
                frameBorder="0"
                id="iframe"
                data-test-id="iframe-browser"
                src={this.state.url}
                style={{
                  display: (this.state.show_source || this.props.compiling) ? 'none' : 'block',
                }}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

BrowserTab.propTypes = propTypes
BrowserTab.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  idToken: state.auth.user.idToken,
  profile: state.hacker.profile,
  path: state.proxy.path,
  search: state.proxy.search,
  requestCount: Object.keys(state.proxy.requests).length,
  state,
  realUrlTabsGenerated: state.proxy.realUrlTabsGenerated,
  proxyTabsData: state.proxy.tabs,
  proxyStatus: state.proxy.status,
  contentDetails: state.content.contentDetails
})

export default withRouter(connect(mapStateToProps, {
  addUrlActivity,
})(BrowserTab))
